import { globalPrompt } from '@/components/message'
import { useLockFn } from 'ahooks'
import { message } from 'antd'
import { createModel } from 'hox'
import { useRef, useState } from 'react'
import { supplierService } from '../../../supplierService'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/ScmTypes'
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from '@/utils/constants'
import {  ISupplierSupplyDetails, ISupplierSupplyDetailsPageSearchFields } from '@/views/supplier/supplierTypes'
import { TablePaginationConfig } from 'antd/lib/table'
import { convertRes2Blob } from '@/utils/exportFile'
import { debounce } from 'lodash'

export const useSupplyDetailsMode = createModel(function () {
    const {setLoadingInfo} = useGlobalModel()
    const supplierCodeRef = useRef('')
    const initSearch = {}
    //查询条件
    const [searchParam, setSearchParam] = useState<ISupplierSupplyDetailsPageSearchFields>(initSearch)
    //列表数据源
    const [dataSource, setDataSource] = useState<ISupplierSupplyDetails[]>([])
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([])
    //列表数据源分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    const [loading, setLoading] = useState<boolean>(false)

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: ISupplierSupplyDetailsPageSearchFields = searchParam) => {
        setLoading(true)
        const searchParams = {
            ...searchValue,
            code: supplierCodeRef.current,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await supplierService.supplyDetailsPage(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(records)
        setLoading(false)
    }

    //导出模版
    const templateDownload = async () => {
         setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            let result =await supplierService.exportSupplyDetailsTemplate()
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { 
            setLoadingInfo({ loadingVisible: false, txt: "" })
         }
    }

    //导入明细
    const importSuppleDetail = async (file: File) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导入中" });
        try {
            let result =await supplierService.importSupplyDetails(file)
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { 
            setLoadingInfo({ loadingVisible: false, txt: "" })
         }
    }

    // 删除
    const handleDelete = async (record: ISupplierSupplyDetails) => {
         globalPrompt('modal', {
            title: '删除',
            type: 'warning',
            text: `确定要删除？`,
            okText: '确定',
            onOk: debounce(
                () =>
                supplierService.deleteSupplyDetails( record.id).then(() => {
                    globalPrompt('message', { text: '删除成功！', type: 'success' })
                     loadData()
                }),
                500
            ),
            cancelText: '取消',
            onCancel: () => {
            },
        })
    }

    // 弹窗
    // 添加弹窗状态
    const [modalVisible, setModalVisible] = useState(false)
    const [modalMode, setModalMode] = useState<'view' | 'edit'>('view')
    const [currentRecord, setCurrentRecord] = useState<ISupplierSupplyDetails | null>(null)


    // 查看操作
    const handleView = (record: ISupplierSupplyDetails) => {
        setCurrentRecord(record)
        setModalMode('view')
        setModalVisible(true)
    }

    // 编辑操作
    const handleEdit = (record: ISupplierSupplyDetails) => {
        setCurrentRecord(record)
        setModalMode('edit')
        setModalVisible(true)
    }

    const handleClose = () => {
        setModalVisible(false)
        setModalMode("view")
        setCurrentRecord(null)
    }

    return {
        searchParam,
        setSearchParam,
        dataSource,
        setDataSource,
        selectedRowKeys,
        setSelectedRowKeys,
        pgCfg,
        setPgCfg,
        loading,
        setLoading,
        loadData,
        supplierCodeRef,
        templateDownload,
        handleDelete,
        handleView,
        handleEdit,
        modalVisible,
        modalMode,
        currentRecord,
        handleClose
    }
})
